/* eslint-disable max-len */
import classNames from 'classnames';
import {createRef, forwardRef, useEffect} from 'react';
import styles from './index.module.scss';
import {isPrivateAndNoPower, isRestrictedAndNoPower} from '@/domains/space/Repository/knowledgeUtils';
import {RootNodeId} from '@/domains/space/Repository/SidebarNew/type';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import {TipsReferenceListSvg} from '@/icons';
import SvgIcon, {IconSize} from '@/components/Icon';
import * as store from '@/store';
import RedDot from '@/domains/space/Repository/components/RedDot';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';


const TabsItem = forwardRef((props: any, wrapRef: any) => {
    const {
        id,
        data = {},
        active,
        slotRight,
        className,
        onClick,
        curDocuments,
        sidebarLoad,
        isDisable,
        repoPermissionRiskCount,
    } = props;

    const {enableSelected = true, icon: Icon} = data;

    const itemRef = createRef<HTMLAnchorElement>();

    useEffect(() => {
        if (active && sidebarLoad) {
            // 根节点定位
            itemRef.current && itemRef.current.scrollIntoView({block: 'center'});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sidebarLoad]);

    function handleClick(e: any) {
        e.stopPropagation();
        e.preventDefault();
        enableSelected && onClick && onClick(data);
    }

    const isDocumentIndex = data.id === RootNodeId.DocumentIndex;
    const isSetting = data.id === RootNodeId.Setting;
    const isTocPage = window.isTocPage || false;
    const isTocRestrictedAndNoPower = isRestrictedAndNoPower() && isTocPage;
    // 目录项在私密知识库会展示’有权限目录‘
    let content = data.text;

    if (isDocumentIndex && curDocuments && curDocuments?.length && (isPrivateAndNoPower() || isTocRestrictedAndNoPower)) {
        content = <>
            <span>有权限目录</span>
            <Tooltip
                trigger={TooltipTrigger.Hover}
                placement="top"
                content={
                    <>
                        <div>以下并不是此知识库的全部内</div>
                        <div>容，仅展示你有权限的页面</div>
                    </>
                }
            >
                <SvgIcon svg={TipsReferenceListSvg} size={IconSize.SM} />
            </Tooltip>
        </>;
    }
    if (isSetting) {
        content = <>
            {data.text}
            <RedDot
                className={styles.repoPermissionRiskRedDotNew}
                count={repoPermissionRiskCount as number}
            >
                <div className={styles.dotWrap}></div>
            </RedDot>
        </>;
    }

    // 查询置顶顺序
    const topNum = wrapRef.current?.dataset?.topnum;

    return (
        <div
            id={id}
            ref={wrapRef}
            className={classNames(
                styles.repoListItem,
                className,
                active && styles.active,
                active && 'node-item-selected', // 该样式固定，提供给其他业务方可以根据该状态设置其自己的 selected 样式
                isDisable && 'node-item-disable',
                topNum && `tree-node-item-top-${topNum}-container`
            )}
        >
            <a
                ref={itemRef}
                className={classNames(styles.link, 'sidebar-nav-item-link')}
                rel="noreferrer"
                href={data.url}
                onClick={handleClick}
            >
                <div
                    className={classNames(styles.repoAvatar)}
                >
                    {
                        Icon && <Icon />
                    }
                </div>
                <span
                    className={classNames(styles.repoName, isDisable && styles.repoNameDisable)}
                >
                    {content}
                </span>
                {slotRight}
            </a>
        </div>
    );
});

// export default TabsItem;
export default TabsItem;
